import { http, HttpResponse } from "msw";
import CsvCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/CsvCatalogItem";
import { runInAction } from "mobx";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
import latLonDateValueCsv from "../../../../wwwroot/test/csv/lat_lon_date_value.csv";
import regionMapping from "../../../../wwwroot/data/regionMapping.json";
describe("CsvCatalogItem", function () {
  let terria;
  let csv;
  beforeEach(function () {
    terria = new Terria();
    csv = new CsvCatalogItem("test", terria, undefined);
    worker.use(http.get("*/build/TerriaJS/data/regionMapping.json", () => HttpResponse.json(regionMapping)));
  });
  it("filters out duplicate discrete times", async function () {
    var _csv$discreteTimes;
    runInAction(() => {
      csv.setTrait("definition", "url", "test/csv/lat_lon_date_value.csv");
    });
    worker.use(http.get("*/test/csv/lat_lon_date_value.csv", () => new HttpResponse(latLonDateValueCsv)));
    await csv.loadMapItems();
    expect((_csv$discreteTimes = csv.discreteTimes) === null || _csv$discreteTimes === void 0 ? void 0 : _csv$discreteTimes.length).toEqual(3);
  });
});